import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowForward = () => {
  return (
    <g>
      <path d="m10.442 2.147.085.073 5.253 5.248a.75.75 0 0 1 .073.977l-.073.084-5.257 5.251a.752.752 0 0 1-1.135-.977l.073-.084 3.969-3.97-7.415.001C2.693 8.75 0 6.063 0 2.75a.75.75 0 0 1 1.503 0 4.505 4.505 0 0 0 4.3 4.495l.212.005h7.419v-.003l-3.97-3.966a.75.75 0 0 1-.072-.977l.072-.084a.752.752 0 0 1 .978-.073z" />
    </g>
  );
};

export default withIcon(IconArrowForward);
